import Icon from '../components/Icon.vue'

Icon.register({
  'dumpster-fire': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M418.7 104.1c-19.7 17.6-37.7 36.5-53.9 55.8h-60.8v-128h100.5l14.4 72zM272 32v128h-126.1l25.6-128h100.5zM461.3 104.1l-11.9-10.6-12.3-61.5h98.9c7.3 0 13.7 5 15.4 12.1l24 96c0.2 0.8-0.1 1.5 0 2.3-1-1-2-2.2-3.1-3.1l-21.3-19-21.3 19c-5.9 5.2-11.6 10.7-17.3 16.3-15.6-17.8-32.9-35.2-51.1-51.5zM16 160c-10.4 0-18-9.8-15.5-19.9l24-96c1.8-7.1 8.2-12.1 15.5-12.1h98.9l-25.6 128h-97.3zM340.6 192c-32.7 46.7-52.6 93.7-52.6 129.6 0 48.5 18.6 92.7 48.8 126.4h-208.8v16c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-16l-20-160h-28c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h20l-4-32h308.6zM551.1 163.2c51.8 46.2 88.9 121.8 88.8 158.4 0 87.5-71.6 158.4-160 158.4-88.4 0-160-70.9-160-158.4 0-49.3 49.8-130.9 120-193.6 27.4 24.4 51.5 50.6 71 76.4 11.9-14 25.3-27.9 40.2-41.2zM532.5 392.6c33.4-24.2 41.2-71.1 22.6-107.8-2.3-4.5-4.9-9.2-7.7-14l-39.8 47s-62.4-82.5-67.1-88.1c-32.9 40.9-49.4 64.8-49.4 91.9 0 54.5 39.9 88 88.9 88 19.6 0 37.8-6.3 52.5-17z'
      }
    ]
  }
})
